import * as React from 'react';
import { Typography } from '@mui/material';
import { CenterCircularProgress } from '@europrocurement/flexy-components';

/**
 * Props pour le composant LoadingModal
 */
interface LoadingModalProps {
    message: string;
}

/**
 * Modal affichée pendant le chargement
 */
export const LoadingModal: React.FunctionComponent<LoadingModalProps> = function ({ message }) {
    return (
        <div
            style={{
                padding: 20,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 12,
            }}
        >
            <CenterCircularProgress />
            <Typography variant="body1">{message}</Typography>
        </div>
    );
};
